<pr-acc-form-summary
  [patientReferenceForm]="patientReferenceForm()"
  [patientForm]="patientForm()"
  [injuryForm]="injuryForm()"
  [employmentForm]="employmentForm()"
  [workCapacityForm]="workCapacityForm()"
  [dentalDiagnosisForm]="dentalDiagnosisForm()"
  [referralForm]="referralForm()"
  [assistanceForm]="assistanceForm()"
  (editStep)="onEditStep($event)"
/>

@if (form(); as formGroup) {
  <form [formGroup]="formGroup">
    <h2 class="!font-medium">Declaration</h2>
    <div>
      <pt-iso-date-selector
        class="w-full"
        placeholder="Declaration Date"
        formControlName="providerDeclaration"
        [required]="true"
        [min]="min"
      />
      @if (formGroup.providerDeclarationRequiredError) {
        <span class="text-xs text-red-500">This field is required</span>
      }
    </div>
  </form>
}
